import { Col, Row } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import TicketDetail from './ticket_detail';
import ticketService from '../../../services/ticketing/ticket.service';
import RequestDocumentForm from './request_document_form';
import EntranceMotion from '../../../helpers/components/entrance_motion';
import myinvoisTransService from '../../../services/myinvois/myinvois_trans.service';
import { useHistory } from 'react-router-dom';
import ContainerComponent from '../../../helpers/components/container.component';
import SimpleNotFoundComponent from '../../../helpers/components/simple_not_found.component';
import globalHelper from '../../../helpers/functions/global.helper';
import moment from 'moment';

const MyInvoisLayout = ({ token, }) => {
    const history = useHistory();
    const [state, setState] = useState({
        loading : false,

        ticket : null,
        submitted_document_line : null,
    })

    const moreThanCutOffDate = useMemo(() => {
        return (moment()?.diff(moment(state?.ticket?.payment_date), 'days') > 3);
    }, [state?.ticket])

    const fetchTicket = async () => {
        setState(state => ({...state, loading : true, }));

        const ticketResponse = await ticketService?.getTicket({
            token,
        });

        const { tickets, } = ticketResponse ?? {};
        const ticket = tickets?.[0];

        setState(state => ({...state, loading : false, ticket, }));
    }

    const fetchDocumentLine = async (ticket_id) => {
        const documentLineResponse = await myinvoisTransService?.fetchDocumentLine({ ticket_id, status : 'Valid', });
        const { document_lines, } = documentLineResponse ?? {};

        // if(document_lines?.length > 0){
        //     // redirect to status page
        //     history.push(`/myinvois/document/${document_lines?.[0]?.document?.document_id}`)
        // }
        setState(state => ({...state, submitted_document_line : document_lines?.[0], }))
    }

    useEffect(() => {
        fetchTicket();
    }, [token])

    // find whether this submission have been submitted, if yes, then redirect to status page
    useEffect(() => {
        if(state?.ticket){
            fetchDocumentLine(state?.ticket?.ticket_id);
        }
    }, [state?.ticket])

    return (
        <>
            {
                state?.submitted_document_line ?
                (
                    <>
                        <ContainerComponent top={20}>
                            <SimpleNotFoundComponent
                            title={'E-Invoice has Submitted'}
                            description={state?.submitted_document_line?.document?.myinvois_document_id}
                            redirect_url={`/myinvois/document/${state?.submitted_document_line?.document?.document_id}`}
                            redirect_name={"View E-Invoice"}
                            />
                        </ContainerComponent>
                    </>
                )
                :
                (
                    <>
                        {
                            // check whether more than 3 days
                            moreThanCutOffDate ? (
                                <>
                                    <ContainerComponent top={20}>
                                        <SimpleNotFoundComponent
                                        title={'E-Invoice requests are only applicable within 3 days of purchase.'}
                                        // description={"E-invoice is required to be submitted within 3 days"}
                                        // redirect_url={`/myinvois/document/${state?.submitted_document_line?.document?.document_id}`}
                                        // redirect_name={"View E-Invoice"}
                                        isBack
                                        />
                                    </ContainerComponent>
                                </>
                            )
                            :
                            (
                                <>
                                    <Row>
                                    {
                                        !globalHelper?.isMobileScreen() &&
                                        (
                                            <>
                                                <Col xs={24} md={12} span={12} className='scroll-item' style={{ background : 'var(--lighten-main-color)', height : 'calc(100vh - 64px)', overflowY : 'auto', }}>
                                                    <div className='mobile-padding-12'>
                                                        <EntranceMotion>
                                                            <TicketDetail ticket={state?.ticket} />
                                                        </EntranceMotion>
                                                    </div>
                                                </Col>
                                            </>
                                        )
                                    }
                                    
                                    <Col xs={24} md={12} span={12}>
                                        <div style={{ minHeight : `calc(100vh - var(--header-height))` }}>
                                            <RequestDocumentForm ticket={state?.ticket} />
                                        </div>
                                    </Col>
                                </Row>
                                </>
                            )
                        }
                        
                    </>
                )
            }
            
        </>
    );
}

export default MyInvoisLayout;